import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { Form, FormikProvider, useFormik } from "formik";
import {
  editKra,
  getAllAssignedKra,
  getAllDesignations,
  getAllKras,
  getAssignedKra,
  tagKra,
} from "../../../../../redux/features/appraisalSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
// import AddKra from "./AddKra";
import EmptyImg from "../../../../../img/empty.jpg";
import Searchbar from "../../../../../components/Search/Searchbar";
import { getAllUsersNew } from "../../../../../redux/features/generalSlice";

const TagUserlibrary = ({ edit, editData, dispatchData, library }) => {
  const [open, setOpen] = useState(false);
  const [selectedKras, setSelectedKras] = useState([]);
  const [kraWeightages, setKraWeightages] = useState({});
  const [selectAll, setSelectAll] = useState(false);
  const [value, setValue] = useState("");
  const [selectedUsers, setSelectedUsers] = useState("");

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, kralibraries } = useSelector((state) => state.appraisal);
  const { allUsers } = useSelector((state) => state.general);

  const ValidationSchema = Yup.object().shape({
    userId: Yup.string().required("Please select a user"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userId: "",
      masterDatas: [
        {
          masterId: null,
          weightage: null,
        },
      ],
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      if (selectedKras.length === 0) {
        enqueueSnackbar(`Please select a ${library}`, {
          variant: "error",
        });
        return;
      }
      const hasEmptyWeight = selectedKras.some(
        (kra) => !kraWeightages[kra.appraisal_library_id]?.toString().trim()
      );

      if (hasEmptyWeight && library === "kra") {
        enqueueSnackbar("Please fill weightage for selected KRAs", {
          variant: "error",
        });
        return;
      }
      const totalWeight = getTotalWeightage();

      if (totalWeight > 100 && library === "kra") {
        enqueueSnackbar("Total weightage cannot exceed 100", {
          variant: "error",
        });
        return;
      }
      const updatedMasterDatas = selectedKras.map((kra) => ({
        masterId: kra.appraisal_library_id,
        weightage: kraWeightages[kra.appraisal_library_id] || "",
      }));
      const updatedMasterDatasSkillandWill = selectedKras.map((kra) => ({
        masterId: kra.appraisal_library_id,
        weightage: 100,
      }));
      const finalPayload = {
        ...values,
        masterDatas:
          library === "kra"
            ? updatedMasterDatas
            : updatedMasterDatasSkillandWill,
      };
      dispatch(tagKra(finalPayload)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          setOpen(false);
          dispatch(getAllAssignedKra(dispatchData));
          setSelectedKras([]);
          setKraWeightages({});
          setSelectedUsers("");
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        }
      });
    },
  });

  // Handle selection logic
  const handleKraToggle = (kra) => {
    const exists = selectedKras.find(
      (item) => item.appraisal_library_id === kra.appraisal_library_id
    );
    if (exists) {
      setSelectedKras((prev) =>
        prev.filter(
          (item) => item.appraisal_library_id !== kra.appraisal_library_id
        )
      );
      const updated = { ...kraWeightages };
      delete updated[kra.appraisal_library_id];
      setKraWeightages(updated);
    } else {
      setSelectedKras((prev) => [...prev, kra]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedKras([]);
      setKraWeightages({});
    } else {
      setSelectedKras(kralibraries);
      const allWeights = {};
      kralibraries.forEach(
        (kra) => (allWeights[kra.appraisal_library_id] = "")
      );
      setKraWeightages(allWeights);
    }
    setSelectAll(!selectAll);
  };

  const handleWeightChange = (id, value) => {
    setKraWeightages({ ...kraWeightages, [id]: value });
  };

  const data = {
    search: value || "",
    type: library,
  };

  useEffect(() => {
    if (open) {
      dispatch(getAllKras(data));
      dispatch(getAllUsersNew());
    }
  }, [open, value]);

  useEffect(() => {
    if (edit && open && editData) {
      const user = {
        name: editData.usertypeDetails.userType,
        userID: editData.usertypeDetails.userTypeId,
      };
      setSelectedUsers(user);
      formik.setFieldValue("userId", user.userID);

      const selected = editData.libraryDetails.map((kra) => ({
        appraisal_library_id: kra.appraisal_library_id,
        appraisal_library_name: kra.libraryName,
      }));
      setSelectedKras(selected);

      const weightageMap = {};
      editData.libraryDetails.forEach((kra) => {
        weightageMap[kra.appraisal_library_id] = kra?.weightage?.toString();
      });
      setKraWeightages(weightageMap);
    }
  }, [edit, open, editData]);

  //   const handleusertype = (e, selectedOptions) => {
  //     const uniqueUsers = Array.from(
  //       new Map(selectedOptions.map((user) => [user.userType, user])).values()
  //     );

  //     setSelectedUsers(uniqueUsers);

  //     const typeIDs = uniqueUsers.map((user) => user.usertypeID);
  //     formik.setFieldValue("userTypeId", typeIDs);
  //   };

  const getTotalWeightage = () => {
    return Object.values(kraWeightages)
      .map((w) => Number(w) || 0)
      .reduce((a, b) => a + b, 0);
  };

  return (
    <GlobalDialog
      title={`Tag ${library}`}
      open={open}
      setOpen={setOpen}
      fullWidth
      fullScreen
      maxWidth={"lg"}
      closeButton={true}
      popupButton={
        edit ? (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            <Icon icon="mdi:pencil" width={18} height={18} />
          </Button>
        ) : (
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => setOpen(true)}
          >
            Tag {library}
          </Button>
        )
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", sm: "center" },
                  flexDirection: { xs: "column", sm: "row" },
                  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
                  borderRadius: "8px",
                  padding: 3,
                }}
              >
                <Autocomplete
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "40%",
                    },
                    mb: 1,
                  }}
                  size="medium"
                  name="Employees"
                  options={allUsers}
                  value={selectedUsers}
                  onChange={(e, selectedOption) => {
                    setSelectedUsers(selectedOption);
                    formik.setFieldValue(
                      "userId",
                      selectedOption?.userID || ""
                    );
                  }}
                  getOptionLabel={(option) => option.name ?? ""}
                  isOptionEqualToValue={(option, value) =>
                    option.userID === value.userID
                  }
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      autoComplete="off"
                      {...params}
                      label="Select User"
                      error={
                        formik.touched.userId && Boolean(formik.errors.userId)
                      }
                      helperText={formik.touched.userId && formik.errors.userId}
                    />
                  )}
                />

                <Box
                  sx={{
                    backgroundColor: "#D372D0",
                    borderRadius: "8px",
                    color: "#fff",
                    px: "10px",
                    py: "8px",
                    fontSize: 14,
                  }}
                >
                  Total {library} weightage limit is 100
                  {selectedKras.length > 0 && (
                    <>
                      <Typography variant="body2">
                        No. of {library} Selected : {selectedKras.length}
                      </Typography>
                      <Typography variant="body2">
                        Total Weightage: {getTotalWeightage()}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>

              <Grid container spacing={2} mt={2}>
                {/* LEFT SIDE: KRA List with Checkboxes */}
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#d2d2d2ff",
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      alignItems: { xs: "flex-start", sm: "center" },
                      justifyContent: "space-between",
                      padding: 1,
                      borderRadius: "8px",
                      mb: 1,
                    }}
                  >
                    <Box
                      display="flex"
                      flexDirection={"row"}
                      alignItems="center"
                    >
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                      <Typography variant="body2">Choose {library}</Typography>
                    </Box>
                    <Box
                      sx={{
                        mb: {
                          xs: 1,
                          sm: 0,
                        },
                      }}
                    >
                      <Searchbar
                        value={value}
                        setValue={setValue}
                        width={"200px"}
                        label={"Search Item"}
                      />
                    </Box>
                    {/* <AddKra dispatchData={data} /> */}
                  </Box>
                  <Stack direction="column" spacing={1}>
                    {kralibraries.map((kra) => (
                      <Box
                        key={kra.appraisal_library_id}
                        display="flex"
                        alignItems="center"
                        sx={{
                          borderRadius: "6px",
                          px: 2,
                          py: 1,
                          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
                        }}
                      >
                        <Checkbox
                          checked={selectedKras.some(
                            (item) =>
                              item.appraisal_library_id ===
                              kra.appraisal_library_id
                          )}
                          onChange={() => handleKraToggle(kra)}
                        />
                        <Typography variant="body2">
                          {kra.appraisal_library_name}
                        </Typography>
                      </Box>
                    ))}
                  </Stack>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{
                      width: "100%",
                      backgroundColor: "#d2d2d2ff",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: 1,
                      borderRadius: "8px",
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2">{library}</Typography>
                    <Typography variant="body2">Weightage</Typography>
                    <Box>
                      <Searchbar
                        value={value}
                        setValue={setValue}
                        width={"200px"}
                        label={"Search Item"}
                      />
                    </Box>
                  </Box>
                  {selectedKras.length < 1 && (
                    <Box
                      display="flex"
                      alignItems={"center"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                    >
                      <img
                        src={EmptyImg}
                        alt=""
                        style={{
                          width: "40%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                      <Typography variant="caption">
                        No records found yet
                      </Typography>
                    </Box>
                  )}

                  <Stack spacing={2}>
                    {selectedKras.map((kra) => (
                      <Box
                        key={kra.appraisal_library_id}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          borderRadius: "6px",
                          px: 2,
                          py: 1,
                          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;",
                        }}
                      >
                        <Typography sx={{ flex: 1 }} variant="body2">
                          {kra.appraisal_library_name}
                        </Typography>
                        {library === "kra" && (
                          <TextField
                            type="text"
                            size="small"
                            label="Weightage"
                            value={
                              kraWeightages[kra.appraisal_library_id] || ""
                            }
                            onChange={(e) =>
                              handleWeightChange(
                                kra.appraisal_library_id,
                                e.target.value
                              )
                            }
                            sx={{ width: "100px", mx: 1 }}
                          />
                        )}
                        <Button
                          color="error"
                          variant="outlined"
                          size="small"
                          onClick={() => handleKraToggle(kra)}
                        >
                          <Icon
                            icon="basil:cross-solid"
                            width={20}
                            height={20}
                          />
                        </Button>
                      </Box>
                    ))}
                  </Stack>
                </Grid>
              </Grid>
              <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}>
                <Stack direction={"row"} spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    disabled={loading}
                    size="small"
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    {loading ? "Please wait..." : "Save"}
                  </Button>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default TagUserlibrary;
